import axiosClient from "../axiosClient"

export const  notificationApi = {
    getAllType:()=>{
        return axiosClient.get('/typeNotification/get-list-type-notification/')
    },
    getAllMethod:()=>{
        return axiosClient.get('/notificationMethod/get-list-notification-method/')
    },
    activeNotification:()=>{
        return axiosClient.get('/userActiveNotification/get-list-user-active-notification/')
    },
    activeNotificationMethod:(method)=>{
        return axiosClient.get(`/userActiveNotification/get-list-user-active-notification/?method=${method}`)
    }
    ,
    offNotification:(method_code,type_code)=>{
        return axiosClient.delete(`/userActiveNotification/delete-remove-user-active-notification/?method_code=${method_code}&type_code=${type_code}`)
    },
    onNotification : (data)=>{
        return axiosClient.post('/userActiveNotification/post-add-user-active-notification/',data)
    },
    getCodeTelegram:()=>{
        return axiosClient.post('/telegramNotification/post-register-telegram-notification/')
    },
    getStatusConnectTele:()=>{
        return axiosClient.get('/telegramNotification/get-state-connect-telegram/')
    },
    getUserNotification:(type)=>{
        return axiosClient.get(`/typeNotification/get-list-user-by-type-notification/?type_notification_code=${type}`)
    },
    checkConnect:(id)=>{
        return axiosClient.post('/telegramNotification/post-test-connect-telegram-notification/',{
            chat_id:id
        })
    },
    connect:(id)=>{
        return axiosClient.post('/telegramNotification/post-update-connect-telegram-notification/',{
            chat_id:id
        })
    },
}